import React, { useEffect, useState } from "react";
import { Input, Row, Col } from "reactstrap";
import XCancel from "../../../assets/img/x-cancel.svg";
import { useFormik } from "formik";
import { addVendorValidate } from "./utils/util";

//redux
import { connect } from "react-redux";
import { createNewVendor } from "../../../redux/actions";
import ButtonLoader from "../../../components/Loaders/ButtonLoader";
import PhoneNumberInput from "../../../components/Inputs/PhoneNumberInput";
import { toast } from "react-toastify";

const AddVendor = ({
  setShowVendor,
  createNewVendor,
  createNewVendorLoading,
  createNewVendorError,
  message,
}) => {
  const [formData, setFormData] = useState(false);

  const handleSelect = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      address: "",
      email: "",
      phone_number: "",
    },
    validate: addVendorValidate,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      formik.validateForm();

      createNewVendor({
        ...values,
        phone_number: formData?.country_code?.concat("", values?.phone_number),
      });
    },
  });
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const payload = {
  //     name: formData.name,
  //     address: formData.address,
  //     email: formData.email,
  //     phone_number: formData?.country_code?.concat("", formData.phone_number),
  //   };
  //   createNewVendor(payload);
  // };

  useEffect(() => {
    if (!createNewVendorLoading && message?.length > 0) {
      toast.success(message);
      setShowVendor(false);
    } else if (!createNewVendorLoading && createNewVendorError?.length > 0) {
      toast.error(createNewVendorError);
    }
  }, [createNewVendorLoading, message, createNewVendorError, setShowVendor]);

  return (
    <div className="off-canvas-menu">
      <div className="off-canvas-menu__content py-2">
        <div className="d-inline-flex w-100 my-3 px-4">
          <div className="add-client-text text-center">
            <h5>Add new vendor</h5>
          </div>
          <img
            onClick={() => setShowVendor(false)}
            className="ms-auto"
            src={XCancel}
            alt=""
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <Row className="px-4 mt-2">
            <Col sm="12" md="12" lg="12" xl="12">
              <label className="text-left w-100">Vendor Name</label>
              <Input
                name="name"
                type="text"
                placeholder=""
                className="off-canvas-menu__input py-3 px-3"
                onChange={formik.handleChange}
                value={formik?.values?.name}
              />
              {formik?.errors?.name && formik?.touched?.name ? (
                <span className="text-danger text-left field-error">
                  {formik?.errors?.name}
                </span>
              ) : null}
            </Col>
            <Col sm="12" md="12" lg="12" xl="12">
              <label className="text-left w-100">Email Address</label>
              <Input
                name="email"
                type="email"
                placeholder=""
                className="off-canvas-menu__input py-3 px-3"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
              {formik?.errors?.email && formik?.touched?.email ? (
                <span className="text-danger text-left field-error">
                  {formik?.errors?.email}
                </span>
              ) : null}
            </Col>
            <Col sm="12" md="12" lg="12" xl="12">
              <label className="text-left w-100 mt-4">Phone Number</label>
              <PhoneNumberInput
                name="phone_number"
                placeholder="Phone number"
                className="off-canvas-menu__input py-3 px-3"
                onChange={formik.handleChange}
                value={formik.values.phone_number}
                onSelect={handleSelect}
              />
              {formik?.errors?.phone_number && formik?.touched?.phone_number ? (
                <span className="text-danger text-left field-error">
                  {formik?.errors?.phone_number}
                </span>
              ) : null}
            </Col>
            <Col sm="12" md="12" lg="12" xl="12">
              <label className="text-left w-100 mt-4">Address</label>
              <Input
                name="address"
                type="textarea"
                placeholder=""
                className="off-canvas-menu__input py-3 px-3"
                onChange={formik.handleChange}
                value={formik.values.address}
              />
              {formik?.errors?.address && formik?.touched?.address ? (
                <span className="text-danger text-left field-error">
                  {formik?.errors?.address}
                </span>
              ) : null}
            </Col>
          </Row>

          <div className="position-absolute bottom-0 w-100">
            <hr />
            <div className="d-flex justify-content-end mt-2 w-100 mb-4 ">
              <button
                className="py-3 px-4 send"
                style={{ marginRight: "18px" }}
                type="submit"
                disabled={createNewVendorLoading}
              >
                {createNewVendorLoading ? <ButtonLoader /> : "Add Vendor"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    createNewVendorLoading: state?.vendors?.createVendorLoading,
    createNewVendorError: state?.vendors?.createNewVendorError,
    message: state?.vendors?.message,
  };
};
export default connect(mapStateToProps, { createNewVendor })(AddVendor);
